module.exports = __webpack_public_path__ + "img/Z81_17.fb2fb7a7.jpg";